import axios from "axios";

export default class AuthService {

  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        "Content-type": "application/json",
        'Access-Control-Max-Age': 600,
        'Cache-Control': 'max-age=600'
      }
    });

    this._setAuthorizationInterceptor();

    this._serviceName = 'security';
  }

  findUserCurrent() {
    return this.http.get(`${this._serviceName}/internal_auth`);
  }

  findCurrent() {
    return this.http.get(`auth/current`);
  }

  _setAuthorizationInterceptor() {
    this.http.interceptors.request.use((config) => {
      let accessToken = localStorage.getItem('access_token');
      if (accessToken) config.headers.common['Authorization'] = `Bearer ${accessToken}`;
      return config;
    });
  }

}
